/**
 * Serene Shell remap. The legacy `colors['--xxx']` keys are kept so the ~30
 * existing consumers re-skin automatically; each value now points at a Serene
 * Shell hue. Old brand blue (triad-blue) -> sage primary; old red -> error red;
 * green/complement -> olive/sage; orange (adjacent) -> warm terracotta.
 * For new code prefer the antd theme tokens (serene-shell.theme.ts).
 */
export const colors = {
  '--white': 'white',
  '--dark-gray': '#1C1C19', // on-surface
  '--light-gray': '#F7F3EF', // surface-low
  '--border-gray': '#C2C8C0', // outline-variant
  '--border-shadow': '#1c1c191f',

  // old red "primary" -> Serene Shell error red family
  '--primary-0': '#BA1A1A',
  '--primary-1': '#D4694A',
  '--primary-2': '#BA1A1A',
  '--primary-3': '#93000A',
  '--primary-4': '#5C0A0A',

  // old brand blue -> SAGE primary family
  '--triad-blue-0': '#4A654E',
  '--triad-blue-1': '#8BA88E',
  '--triad-blue-2': '#4A654E',
  '--triad-blue-3': '#3C5440',
  '--triad-blue-4': '#23402B', // dark sage (dark text / dark surfaces)

  // old green -> muted olive (tertiary)
  '--triad-green-0': '#5C6145',
  '--triad-green-1': '#9FA484',
  '--triad-green-2': '#5C6145',
  '--triad-green-3': '#45492F',
  '--triad-green-4': '#363A21',

  // complement green -> sage / success
  '--complement-0': '#4A654E',
  '--complement-1': '#8BA88E',
  '--complement-2': '#4A654E',
  '--complement-3': '#3C5440',
  '--complement-4': '#23402B',

  // adjacent orange -> warm terracotta (secondary)
  '--adjacent-0': '#7D562D',
  '--adjacent-1': '#F0BD8B',
  '--adjacent-2': '#FFCA98',
  '--adjacent-3': '#623F18',
  '--adjacent-4': '#2C1600',
};
